export const footerPuns = [
  "Pic 'n' mix",
  'A picture to hoot you',
  'Speak softly and carry a big Pic',
  "Pictures with bite that won't drain your wallet",
  'Hoots you, sir!',
  'I vant to show you pics',
  'Pic me up before you go go',
  'I-gorgeous mockups',
  'Scarily awesome',
  'You want good pics, not look like a twit do you?',
  'Nosferat-HOO',
  'Something to get your teeth into',
  'We scare about giving you quality mockups',
  'Give your mockups some bite',
  "Don't be a sucker, give your pics some bite!",
  'Too many pics to count',
  'Make your screenshots count',
  "I'm counting all the pics, it's a hoot",
  'Pics that go bump in the night',
  'Quality pics, no reflections',
  'Owl always have pics for you',
  'Sucking your blood, not your pictures',
  'Scare to be different',
  'Hoot have thought it would be so easy?',
  'Bats are sooooo last century!',
  'No need to wing it with these pics!',
  'Mockups to bat an eye at!',
  'Making mockups sanguine',
  'HOO DARES DISTURB MY SLUMBER??',
  'Pic or treat!',
  'Count your blessings',
  'I challenge you to a pun-down at sun-down!',
  'Fangs for stopping by!'
];



// WEBPACK FOOTER //
// ./src/utils/puns.js